/* DailyKickz - Combi-deal bouwer: klant kiest zelf trainingspak + t-shirt voor een vaste totaalprijs. */
(function () {
'use strict';
var KINDS = {
set: {
handle: 'setHandle', title: 'Kies uw trainingspak', pickTxt: 'Kies dit trainingspak',
ok: function (n) { return n.indexOf('hoodie') > -1 && n.indexOf('pants') > -1; }
},
tee: {
handle: 'teeHandle', title: 'Kies uw t-shirt', pickTxt: 'Kies dit t-shirt',
ok: function (n) { return n.length === 1; }
}
};
var lists = {};
var modal = null;
var ctx = null;
function esc(s) {
return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
});
}
function money(n, cur) {
var whole = Math.abs(n - Math.round(n)) < 0.005;
try {
return new Intl.NumberFormat('nl-NL', {
style: 'currency', currency: cur || 'EUR',
minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: whole ? 0 : 2
}).format(n).replace(/\s/g, '');
} catch (e) {
return '€' + (whole ? Math.round(n) : n.toFixed(2).replace('.', ','));
}
}
function m(n, c) { return esc(money(n, c)); }
function show(n) { var c = Math.ceil(n - 1e-9); return c - n > 0.005 && c - n <= 0.1 ? c : n; }
function thumb(src, w) {
if (!src) return '';
return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
}
function uniq(arr) {
var out = [];
arr.forEach(function (x) { if (x != null && out.indexOf(x) < 0) out.push(x); });
return out;
}
function normalize(p) {
var vs = (p.variants || []).map(function (v) {
return { id: v.id, o1: v.option1, o2: v.option2, price: parseFloat(v.price) || 0, ok: v.available !== false };
});
var img = (p.images && p.images[0] && p.images[0].src) || (p.image && p.image.src) || '';
return {
id: p.id, title: p.title, handle: p.handle, img: img, variants: vs,
price: vs.length ? Math.min.apply(null, vs.map(function (v) { return v.price; })) : 0
};
}
function fetchList(rootUrl, handle, kind) {
var key = handle + '|' + kind;
if (lists[key]) return lists[key];
var all = [];
function page(n) {
return fetch(rootUrl + 'collections/' + handle + '/products.json?limit=250&page=' + n, { headers: { Accept: 'application/json' } })
.then(function (r) { if (!r.ok) throw new Error('http ' + r.status); return r.json(); })
.then(function (j) {
var ps = j.products || [];
all = all.concat(ps);
return ps.length >= 250 && n < 6 ? page(n + 1) : all;
});
}
lists[key] = page(1).then(function (ps) {
return ps.filter(function (p) {
var tags = Array.isArray(p.tags) ? p.tags : String(p.tags || '').split(',');
if (tags.map(function (t) { return String(t).trim().toLowerCase(); }).indexOf('combideal') > -1) return false;
var names = (p.options || []).map(function (o) { return String(o.name || '').toLowerCase(); });
return KINDS[kind].ok(names) && (p.variants || []).length > 0;
}).map(normalize);
}).catch(function (e) { delete lists[key]; throw e; });
return lists[key];
}
function buildModal() {
modal = document.createElement('div');
modal.className = 'dkcb-modal';
modal.hidden = true;
modal.setAttribute('role', 'dialog');
modal.setAttribute('aria-modal', 'true');
modal.setAttribute('aria-labelledby', 'dkcb-mt');
modal.innerHTML =
'<div class="dkcb-modal__bg" data-close></div>' +
'<div class="dkcb-modal__panel">' +
'<div class="dkcb-modal__head">' +
'<button type="button" class="dkcb-modal__btn" data-back hidden aria-label="Terug">‹</button>' +
'<h3 class="dkcb-modal__title" id="dkcb-mt"></h3>' +
'<button type="button" class="dkcb-modal__btn" data-close aria-label="Sluiten">×</button>' +
'</div>' +
'<div class="dkcb-modal__body"></div>' +
'</div>';
document.body.appendChild(modal);
modal.addEventListener('click', function (e) {
if (e.target.closest('[data-close]')) closeModal();
else if (e.target.closest('[data-back]')) showList();
});
document.addEventListener('keydown', function (e) {
if (e.key === 'Escape' && modal && !modal.hidden) closeModal();
});
}
function body() { return modal.querySelector('.dkcb-modal__body'); }
function openModal(inst, kind) {
if (!modal) buildModal();
ctx = { inst: inst, kind: kind, items: null, item: null, h: null, p: null, q: '' };
modal.hidden = false;
document.documentElement.classList.add('dkcb-lock');
var cur = inst.sel[kind];
if (cur) {
ctx.item = cur.item; ctx.h = cur.h; ctx.p = cur.p;
showDetail();
} else {
showList();
}
inst.load(kind).then(function (items) { ctx && (ctx.items = items); if (ctx && ctx.view === 'list') renderGrid(); }).catch(function () {});
var x = modal.querySelector('[data-close].dkcb-modal__btn');
if (x) x.focus();
}
function closeModal() {
if (!modal || modal.hidden) return;
modal.hidden = true;
document.documentElement.classList.remove('dkcb-lock');
var inst = ctx && ctx.inst, kind = ctx && ctx.kind;
ctx = null;
var slot = inst && inst.root.querySelector('[data-slot="' + kind + '"]');
if (slot) slot.focus();
}
function showList() {
ctx.view = 'list';
modal.querySelector('#dkcb-mt').textContent = KINDS[ctx.kind].title;
modal.querySelector('[data-back]').hidden = true;
body().innerHTML =
'<input type="search" class="dkcb-search" placeholder="Zoek op naam of kleur" aria-label="Zoeken" autocomplete="off">' +
'<div data-grid></div>';
var s = body().querySelector('.dkcb-search');
s.value = ctx.q || '';
s.addEventListener('input', function () { ctx.q = s.value; renderGrid(); });
renderGrid();
}
function renderGrid() {
var box = body().querySelector('[data-grid]');
if (!box) return;
if (!ctx.items) {
box.innerHTML = '<div class="dkcb-msg">Producten laden…</div>';
ctx.inst.load(ctx.kind).then(function (items) {
if (!ctx) return;
ctx.items = items;
if (ctx.view === 'list') renderGrid();
}).catch(function () {
if (!ctx || ctx.view !== 'list') return;
box.innerHTML = '<div class="dkcb-msg">De producten konden niet worden geladen.<br><button type="button" data-retry>Opnieuw proberen</button></div>';
var b = box.querySelector('[data-retry]');
if (b) b.addEventListener('click', function () { renderGrid(); });
});
return;
}
var words = String(ctx.q || '').toLowerCase().split(/\s+/).filter(Boolean);
var list = ctx.items.filter(function (it) {
var t = it.title.toLowerCase();
return words.every(function (w) { return t.indexOf(w) > -1; });
});
if (!list.length) { box.innerHTML = '<div class="dkcb-msg">Geen resultaten gevonden.</div>'; return; }
var cur = ctx.inst.cur;
box.innerHTML = '<div class="dkcb-grid">' + list.map(function (it, i) {
var out = !it.variants.some(function (v) { return v.ok; });
var deal = ctx.kind === 'tee' ? ctx.inst.teeDeal(it) : 0;
return '<button type="button" class="dkcb-card' + (out ? ' is-out' : '') + '" data-i="' + i + '"' + (out ? ' disabled' : '') + '>' +
'<span class="dkcb-card__img"><img src="' + esc(thumb(it.img, 400)) + '" alt="" loading="lazy" width="400" height="400"></span>' +
'<span class="dkcb-card__name">' + esc(it.title) + '</span>' +
'<span class="dkcb-card__price">' + (out ? 'Uitverkocht' : (deal ? '<s>' + m(show(it.price), cur) + '</s> <strong>' + m(deal, cur) + '</strong> in de deal' : 'Los ' + m(it.price, cur))) + '</span>' +
'</button>';
}).join('') + '</div>';
box.querySelectorAll('.dkcb-card').forEach(function (btn) {
btn.addEventListener('click', function () {
ctx.item = list[parseInt(btn.getAttribute('data-i'), 10)];
ctx.h = null; ctx.p = null;
showDetail();
});
});
}
function showDetail() {
ctx.view = 'detail';
var it = ctx.item, kind = ctx.kind, cur = ctx.inst.cur;
var dealD = kind === 'tee' ? ctx.inst.teeDeal(it) : 0;
modal.querySelector('#dkcb-mt').textContent = KINDS[kind].title;
modal.querySelector('[data-back]').hidden = false;
var groups = kind === 'set'
? [{ k: 'h', label: 'Hoodie maat', sizes: uniq(it.variants.map(function (v) { return v.o1; })) },
{ k: 'p', label: 'Broek maat', sizes: uniq(it.variants.map(function (v) { return v.o2; })) }]
: [{ k: 'h', label: 'Maat', sizes: uniq(it.variants.map(function (v) { return v.o1; })) }];
body().innerHTML =
'<div class="dkcb-d">' +
'<div class="dkcb-d__img"><img src="' + esc(thumb(it.img, 800)) + '" alt="' + esc(it.title) + '"></div>' +
'<div class="dkcb-d__info">' +
'<h4 class="dkcb-d__name">' + esc(it.title) + '</h4>' +
'<p class="dkcb-d__price">' + (dealD ? '<s>' + m(show(it.price), cur) + '</s> <strong>' + m(dealD, cur) + '</strong> in de combi-deal' : 'Los ' + m(it.price, cur) + ', in de combi-deal zit dit inbegrepen') + '</p>' +
groups.map(function (g) {
return '<div class="dkcb-d__grp" style="margin-top:16px"><span class="dkcb-d__lbl">' + g.label + '</span><div class="dkcb-pills" data-g="' + g.k + '">' +
g.sizes.map(function (sz) {
var ok = it.variants.some(function (v) { return (g.k === 'h' ? v.o1 : v.o2) === sz && v.ok; });
return '<button type="button" class="dkcb-pill" data-v="' + esc(sz) + '" aria-pressed="false"' + (ok ? '' : ' disabled') + '>' + esc(sz) + '</button>';
}).join('') +
'</div></div>';
}).join('') +
'<p class="dkcb-d__tip"><strong>Maatadvies:</strong> Neem een maat kleiner dan uw gebruikelijke maat</p>' +
'<div style="margin-top:20px"><button type="button" class="dkcb-pick" data-pick disabled></button></div>' +
'</div>' +
'</div>';
var pick = body().querySelector('[data-pick]');
function sync() {
body().querySelectorAll('.dkcb-pills').forEach(function (box) {
var k = box.getAttribute('data-g');
box.querySelectorAll('.dkcb-pill').forEach(function (b) {
b.setAttribute('aria-pressed', ctx[k] === b.getAttribute('data-v') ? 'true' : 'false');
});
});
var v = findVariant();
var need = kind === 'set' ? (!ctx.h || !ctx.p) : !ctx.h;
pick.disabled = need || !v;
pick.textContent = need ? 'Kies eerst uw maat' : (v ? KINDS[kind].pickTxt : 'Combinatie niet beschikbaar');
}
function findVariant() {
return it.variants.filter(function (v) {
return v.o1 === ctx.h && (kind === 'tee' || v.o2 === ctx.p) && v.ok;
})[0] || null;
}
body().querySelectorAll('.dkcb-pill').forEach(function (b) {
b.addEventListener('click', function () {
ctx[b.parentNode.getAttribute('data-g')] = b.getAttribute('data-v');
sync();
});
});
pick.addEventListener('click', function () {
var v = findVariant();
if (!v) return;
var inst = ctx.inst;
inst.sel[kind] = { item: it, h: ctx.h, p: ctx.p, variant: v };
closeModal();
inst.update();
});
sync();
body().scrollTop = 0;
}
function Builder(root) {
var self = this;
this.root = root;
this.cur = root.getAttribute('data-currency') || 'EUR';
this.total = parseFloat(root.getAttribute('data-total')) || 0;
this.setRef = parseFloat(root.getAttribute('data-set-ref')) || 0;
this.teeRef = parseFloat(root.getAttribute('data-tee-ref')) || 0;
this.rootUrl = root.getAttribute('data-root') || '/';
if (this.rootUrl.slice(-1) !== '/') this.rootUrl += '/';
this.sel = { set: null, tee: null };
this.form = root.querySelector('form');
this.hint = root.querySelector('[data-hint]');
this.submit = root.querySelector('[type="submit"]');
root.querySelectorAll('[data-slot]').forEach(function (btn) {
var kind = btn.getAttribute('data-slot');
btn.addEventListener('click', function () { openModal(self, kind); });
['pointerenter', 'touchstart', 'focus'].forEach(function (ev) {
btn.addEventListener(ev, function () { self.load(kind).catch(function () {}); }, { passive: true, once: true });
});
});
root.querySelectorAll('[data-clear]').forEach(function (btn) {
btn.addEventListener('click', function (e) {
e.stopPropagation();
self.sel[btn.getAttribute('data-clear')] = null;
self.update();
});
});
this.submit.addEventListener('click', function (e) {
var missing = !self.sel.set ? 'set' : (!self.sel.tee ? 'tee' : null);
if (!missing) return;
e.preventDefault();
e.stopPropagation();
var row = root.querySelector('.dkcb__row');
row.classList.remove('is-shake');
void row.offsetWidth;
row.classList.add('is-shake');
openModal(self, missing);
}, true);
this.update();
}
Builder.prototype.load = function (kind) {
var handle = this.root.getAttribute('data-' + (kind === 'set' ? 'set' : 'tee') + '-handle');
return fetchList(this.rootUrl, handle, kind);
};
Builder.prototype.teeDeal = function (item) {
var setPrice = this.sel.set ? this.sel.set.variant.price : this.setRef;
var deal = setPrice > 0 ? this.total - setPrice : 0;
return deal > 0.005 && item.price - deal > 0.005 ? deal : 0;
};
Builder.prototype.setProp = function (name, value) {
var input = this.form.querySelector('[data-prop="' + name + '"]');
if (!input) return;
input.value = value || '';
input.disabled = !value;
};
Builder.prototype.update = function () {
var self = this, cur = this.cur, sel = this.sel, n = 0;
['set', 'tee'].forEach(function (kind) {
var cell = self.root.querySelector('[data-slot="' + kind + '"]');
var empty = cell.querySelector('.dkcb__empty'), filled = cell.querySelector('.dkcb__filled');
var clear = self.root.querySelector('[data-clear="' + kind + '"]');
var s = sel[kind];
if (s) {
n++;
var sizeTxt = kind === 'set' ? 'Hoodie ' + s.h + ' · Broek ' + s.p : 'Maat ' + s.h;
filled.innerHTML = '<span class="dkcb__pic"><img src="' + esc(thumb(s.item.img, 400)) + '" alt=""></span>' +
'<span class="dkcb__meta"><span class="dkcb__name">' + esc(s.item.title) + '</span><span class="dkcb__size">' + esc(sizeTxt) + '</span></span>';
filled.hidden = false; empty.hidden = true;
cell.classList.add('is-filled');
clear.hidden = false;
cell.setAttribute('aria-label', 'Wijzig ' + (kind === 'set' ? 'trainingspak' : 't-shirt'));
} else {
filled.hidden = true; empty.hidden = false;
cell.classList.remove('is-filled');
clear.hidden = true;
cell.setAttribute('aria-label', 'Kies ' + (kind === 'set' ? 'trainingspak' : 't-shirt'));
}
});
var tot = money(this.total, cur);
var setPrice = sel.set ? sel.set.variant.price : this.setRef;
var teeLos = sel.tee ? sel.tee.variant.price : this.teeRef;
var teeDeal = setPrice > 0 ? this.total - setPrice : 0;
var teeSave = teeLos - teeDeal;
var teeShow = show(teeLos);
var heeftTee = teeDeal > 0.005 && teeSave > 0.005;
var teeTxt = heeftTee ? '<strong>' + m(teeDeal, cur) + '</strong> <s>' + m(teeShow, cur) + '</s>' : '';
if (n === 2) {
this.hint.innerHTML = 'Uw combi-deal: samen <strong>' + esc(tot) + '</strong>';
} else {
this.hint.innerHTML = (n === 1 ? 'Kies nog <strong>1 product</strong>' : 'Kies een trainingspak en een t-shirt') +
(heeftTee ? '<em class="dkcb__was">T-shirt ' + teeTxt + ' · samen ' + esc(tot) + '</em>' : '<em class="dkcb__was">Samen <strong>' + esc(tot) + '</strong></em>');
}
this.submit.classList.toggle('is-incomplete', n < 2);
var s1 = sel.set, s2 = sel.tee;
this.setProp('set', s1 ? s1.item.title + ' (Hoodie ' + s1.h + ', Broek ' + s1.p + ')' : '');
this.setProp('tee', s2 ? s2.item.title + ' (Maat ' + s2.h + ')' : '');
this.setProp('set_variant', s1 ? String(s1.variant.id) : '');
this.setProp('tee_variant', s2 ? String(s2.variant.id) : '');
this.setProp('set_url', s1 ? '/products/' + s1.item.handle : '');
this.setProp('tee_url', s2 ? '/products/' + s2.item.handle : '');
};
function init() {
document.querySelectorAll('[data-dkcb]').forEach(function (el) {
if (el.__dkcb) return;
el.__dkcb = new Builder(el);
});
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
else init();
document.addEventListener('shopify:section:load', init);
})();